import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {LocalCustomerAnagrafService} from '../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import * as toastr from 'toastr';
import {LocalCustomerSettingsModel} from '../../../models/LocalCustomerSettingsModel';
import {RegionModel} from '../../../models/RegionModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../models/CurrencyModel';
import {Router} from '@angular/router';
import {ContractualDataModel} from '../../../models/ContractualDataModel';
import {LoaderService} from '../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-local-customer-anagraf',
  templateUrl: './local-customer-anagraf.component.html',
  styleUrls: ['./local-customer-anagraf.component.scss']
})
export class LocalCustomerAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  filter: LocalCustomerModel;
  filterInSettings: LocalCustomerSettingsModel;
  filterAllInSettings: AllSettingsFilterModel;
  contractFilter: ContractualDataModel;

  displayedColumns: Array<string>;
  dataSource: any;
  isAnagraphSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;
  initAfterOnChange: boolean;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() multipleSelection?: boolean;
  @Input() inLocalCustomerSettings?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() inAllContractMonth?: boolean;

  @Input() regionForFilterInSettings?: RegionModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() providerForFilterInSettings?: ProviderModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;

  @Input() providerListForFilterInSettings?: Array<ProviderModel>;
  @Input() regionListForFilterInSettings?: Array<RegionModel>;
  @Input() contractTypeListForFilterInSettings?: Array<ContractTypeModel>;

  @Input() localCustomerSelectedList?: Array<LocalCustomerModel>;

  @Input() numAnnoMeseFromForFilterInSettings?: number;
  @Input() numAnnoMeseToForFilterInSettings?: number;

  @Output() elementSelected = new EventEmitter();

  constructor(private localCustomerService: LocalCustomerAnagrafService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.showActions = true;
    this.inLocalCustomerSettings = false;
    this.multipleSelection = false;
    this.regionForFilterInSettings = null;
    this.contractTypeForFilterInSettings = null;
    this.resourceUnitForFilterInSettings = null;

    this.offset = new Offset();
    this.filter = new LocalCustomerModel();
    this.filterInSettings = new LocalCustomerSettingsModel();
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('regionForFilterInSettings' in changes
      || 'contractTypeForFilterInSettings' in changes
      || 'resourceUnitForFilterInSettings' in changes
      || 'designServicesForFilterInSettings' in changes
      || 'currencyForFilterInSettings' in changes
      || 'regionListForFilterInSettings' in changes
      || 'contractTypeListForFilterInSettings' in changes
      || 'providerListForFilterInSettings' in changes) {
        this.initAfterOnChange = true;
      this.getAll(this.offset);
    }
  }

  ngOnInit() {
    if (this.showActions === true) {
      this.displayedColumns = ['LocalCustomerCod', 'localCustomerDesc',
                              'inLocalCustomerSett', 'actions'];
    } else {
      if (this.multipleSelection) {
        this.displayedColumns = ['isSelected', 'LocalCustomerCod', 'localCustomerDesc'];
      } else {
        this.displayedColumns = ['LocalCustomerCod', 'localCustomerDesc'];
      }

    }

    this.pageSize = 10;
    this.setOffsetInSession();
    if (!this.initAfterOnChange) {
      this.getAll(this.offset);
    }
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.inLocalCustomerSettings) {
      this.filterInSettings = new LocalCustomerSettingsModel(null, this.filter, this.regionForFilterInSettings);
      this.getPageSubscribe = this.localCustomerService.getPageInLocalCustomerSettings(offset, this.filterInSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else if (this.inAllSettings) {
      this.filterAllInSettings = new AllSettingsFilterModel();

      this.filterAllInSettings.region = this.regionForFilterInSettings;
      this.filterAllInSettings.resourceUnit = this.resourceUnitForFilterInSettings;
      this.filterAllInSettings.localCustomer = this.filter;
      this.filterAllInSettings.provider = this.providerForFilterInSettings;
      this.filterAllInSettings.contractType = this.contractTypeForFilterInSettings;

      this.filterAllInSettings.regionList = this.regionListForFilterInSettings;
      this.filterAllInSettings.contractTypeList = this.contractTypeListForFilterInSettings;
      this.filterAllInSettings.providerList = this.providerListForFilterInSettings;

      this.getPageSubscribe = this.localCustomerService.getPageInAllSettings(offset, this.filterAllInSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.setChecked();
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else if (this.inAllContractMonth) {
      this.contractFilter = new ContractualDataModel();
      this.contractFilter.numAnnoMeseFrom = this.numAnnoMeseFromForFilterInSettings;
      this.contractFilter.numAnnoMeseTo = this.numAnnoMeseToForFilterInSettings;
      this.contractFilter.region = this.regionForFilterInSettings;
      this.contractFilter.resourceUnit = this.resourceUnitForFilterInSettings;
      this.contractFilter.contractType = this.contractTypeForFilterInSettings;
      this.contractFilter.provider = this.providerForFilterInSettings;
      this.contractFilter.localCustomer = this.filter;
      this.getPageSubscribe = this.localCustomerService.getPageInAllContractMonth(offset, this.contractFilter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else {
      this.getPageSubscribe = this.localCustomerService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }

  filterTable() {
    this.getAll(this.offset);
  }

  resetTable() {
    this.filter = new LocalCustomerModel();
    this.getAll(new Offset(10, 0));
  }
  openDialog(id: number) {
    const regionData = this.dataSource.find(data => data.id === id) as RegionModel;
    const list: GenericArray[] = [
      { id: 'Local Customer Cod', value: regionData.cod.toString() },
      { id: 'Local Customer Description', value: regionData.description.toString() }
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.localCustomerService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Local Customer with id ' + id + ' was deleted with success', 'Success');

              this.getAll(this.offset);
            } else {
              toastr.info('Local Customer cannot be deleted', 'Alert');
            }

          }, error => {
            toastr.error('Local Customer with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    if (!this.multipleSelection) {
      this.elementSelected.emit({ row });
    }
  }

  selectMultipleRow(row: any) {
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('localCustomerOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('localCustomerOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
      this.pageSize = this.offset.pageSize;
    }
  }


  setChecked() {
    if (this.localCustomerSelectedList && this.localCustomerSelectedList.length > 0) {
      for (let _i = 0; _i < this.dataSource.length; _i++) {
        const localCustomer: LocalCustomerModel = this.dataSource[_i];
        for (let _j = 0; _j < this.localCustomerSelectedList.length; _j++) {
          if (localCustomer.id ===  this.localCustomerSelectedList[_j].id) {
            localCustomer.checked = true;
          }
        }
      }
    }
  }
}
